import  axios  from "axios";

//apply base url for axios
// Loan URL
//export const API_URL = "https://localhost:7095";

//Production URL
export const API_URL = "http://10.60.2.46/JSBOnlineAccountAPI";
//export const API_URL = "http://oaom.jsbnet.in/JSBOnlineAccountAPI";

//Development URL of VM
//export const API_URL = "http://20.198.83.226/JSBOnlineAccountAPI";

//QA URL of VM
//export const API_URL = "http://20.198.83.226/JSBOnlineAccountAPIQA"; 

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
);1

export function getAPIUrl() {
    return API_URL;
}

export async function get(url, config = {}) {
    return await axiosApi.get(url, { ...config }).then(response => response.data);
}

export async function post(url, data, config = {}) {
    debugger;
    return axiosApi
        .post(url, { ...data }, { ...config })
        .then(response => response.data);
}

export async function put(url, data, config = {}) {
    return axiosApi
        .put(url, { ...data }, { ...config })
        .then(response => response.data);
}

export async function del(url, config = {}) {
    return await axiosApi
        .delete(url, { ...config })
        .then(response => response.data);
}